export const environment = {
    PRODUCT_MODE: true,
    API_URL: 'https://portal-apis.weset.edu.vn',
};
